import {
  gitCheckoutBranchSuccess,
  gitConnectSuccess,
  gitCreateReleaseTagInit,
  gitDiscardSuccess,
  gitImportSuccess,
  gitPullSuccess,
} from "git/store";
import { all, takeLatest } from "redux-saga/effects";
import packageRedirectToClosestEntitySaga from "./packageRedirectToClosestEntitySaga";
import packageConnectToGitSaga from "./packageConnectToGitSaga";
import packageImportFromGitSaga from "./packageImportFromGitSaga";
import packageCreateReleaseTagSaga from "./packageCreateReleaseTagSaga";

export default function* gitPackageSagas() {
  yield all([
    takeLatest(gitConnectSuccess.type, packageConnectToGitSaga),
    takeLatest(gitImportSuccess.type, packageImportFromGitSaga),
    takeLatest(gitDiscardSuccess.type, packageRedirectToClosestEntitySaga),
    takeLatest(
      gitCheckoutBranchSuccess.type,
      packageRedirectToClosestEntitySaga,
    ),
    takeLatest(gitPullSuccess.type, packageRedirectToClosestEntitySaga),
    takeLatest(gitCreateReleaseTagInit.type, packageCreateReleaseTagSaga),
  ]);
}
